import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgProgressService } from '../../../services/ngProgress.service';
import { Quote, QuoteDetail, StockLines } from '../../../models/quote.model';
import { QuoteService } from '../../../services/quote.service';
import { Subscription } from 'rxjs/Subscription';
import { Sort } from '@angular/material/sort';
import { TablefilterMultiplePipe } from '../../../shared/pipes/tablefilter-multiple.pipe';
import { switchMap } from 'rxjs/operators';
import { CommonService} from '../../../services';
import { of } from 'rxjs';

@Component({
  selector: 'app-price-list-detail',
  templateUrl: './price-list-detail.component.html',
  styleUrls: ['./price-list-detail.component.css']
})
export class PriceListDetailComponent implements OnInit, OnDestroy {

  title: string = 'PRICE LIST DETAIL';
  quote: Quote;
  quoteDetail: QuoteDetail;
  quoteId: string;
  version: string = '0';
  subscriptionActiveRouter$: Subscription;
  subscriptionQuote$: Subscription;
  subscriptionQuoteDetails$: Subscription;
  p: number = 1;
  pageloaded: boolean = false;
  loadContent: boolean = false;
  stockLines: StockLines[];
  sortedData: StockLines[];


  filterInput: string;
  filterResultArr: any;
  hasEmptyFilterResult: boolean = false;

  urlPath: string;
  quoteListSubscription: Subscription;

  expiry: string;

  //isValid: boolean = true;

  constructor(
    private router: Router,
    private ngProgress: NgProgressService,
    private activeRouter: ActivatedRoute,
    private quoteService: QuoteService,
    private commonService: CommonService
  ) { }

  sortData(sort: Sort) {
    const data = this.stockLines.slice();


    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }
    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'stockDesc': return compare(a.stockDesc.toLowerCase(), b.stockDesc.toLowerCase(), isAsc);
        case 'stockOnHand': return compare(parseInt(a.stockOnHand), parseInt(b.stockOnHand), isAsc);
        case 'price': return compare(parseInt(a.price), parseInt(b.price), isAsc);
        case 'quantity': return compare(parseInt(a.quantity), parseInt(b.quantity), isAsc);
        case 'lineTotal': return compare(parseInt(a.lineTotal), parseInt(b.lineTotal), isAsc);
        default: return 0;
      }
    });

  }

  onChange() {
    this.filterResultArr = new TablefilterMultiplePipe().transform(this.sortedData, ['stockDesc', 'stockOnHand', 'price', 'quantity', 'lineTotal'], this.filterInput);
    if (this.filterResultArr.length === 0) {
      this.hasEmptyFilterResult = true;

    } else {
      this.hasEmptyFilterResult = false;
    }
  }

  filterReset() {
    this.filterInput = '';
    this.hasEmptyFilterResult = false;
  }

  ngOnInit() {
    this.activeRouter.parent.url.subscribe(url => {
      this.urlPath = url[0].path;
      //console.info(url);
    },
      (error: any) => {
        console.info(error);
        this.ngProgress.done();
      });

    this.activeRouter.paramMap.subscribe(
      param => {
        this.ngProgress.start();
        this.pageloaded = false;
        this.loadContent = false;
        this.quoteId = param.get('sku');
        this.version = param.get('version');
        // $('.combination-loader').animate(
        //   { scrollLeft: (250) },
        //   {
        //     duration: 100,
        //     complete: function () {
        //       //console.log('animation stops');
        //       $('.combination-loader').stop(true, false);
        //     }
        //   });

        $('#levelOne').animate(
          { scrollLeft: (252) },
          {
            duration: 400,
            complete: function () {
              $('.combination-loader').stop(true, false);
            }
          });

        this.quoteListSubscription = this.quoteService.priceList$.asObservable().pipe(
          switchMap((quotes: Quote[]) => {
            if (quotes.length > 0) {
              return of(quotes)
            } else {
              return this.quoteService.getQuoteList(true)
            }
          })
        ).subscribe((value: Quote[]) => {

          this.loadContent = false;

          this.subscriptionQuoteDetails$ = this.quoteService.getQuoteDetails(this.quoteId, this.version).subscribe(
            (data: QuoteDetail) => {
              this.expiry = data.quoteHeader.expiryDate;
              this.quoteDetail = data;
              this.stockLines = data.stockLines;
              this.sortedData = this.stockLines.slice();

              this.pageloaded = true;
              this.loadContent = true;
            }, (error: any) => {
              console.info(error);
              this.loadContent = true;
              this.ngProgress.done();
            },
          );

        })

      });

    this.ngProgress.done();
  }

  ngOnDestroy() {
    this.pageloaded = false;
    if (this.subscriptionActiveRouter$) {
      this.subscriptionActiveRouter$.unsubscribe();
    }

    if (this.subscriptionQuote$) {
      this.subscriptionQuote$.unsubscribe();
    }

    if (this.subscriptionQuoteDetails$) {
      this.subscriptionQuoteDetails$.unsubscribe();
    }

    if (this.quoteListSubscription) {
      this.quoteListSubscription.unsubscribe();
    }
  }

  updateQty(quantity: string, index: number): void {

    const stock = this.sortedData[index];

    let qty = parseInt(quantity);

    if (isNaN(qty)) {
      this.commonService.implementToast("Qty must be a valid number", "Error");
      stock.quantity = stock.min;
    } else if (qty > Number(stock.max)) {
      this.commonService.implementToast(`The max qty is ${stock.max} `, "Error");
      stock.quantity = stock.min;
    } else if (qty < Number(stock.min)) {
      this.commonService.implementToast(`The min qty is ${stock.min} `, "Error");
      stock.quantity = stock.min;
    }
    stock.lineTotal = (Number(stock.price) * Number(stock.quantity)).toString()

    // let valid = true;
    // for (let i = 0; i < this.sortedData.length; i++) {
    //   if (isNaN(parseInt(this.sortedData[i].quantity)) || Number(this.sortedData[i].quantity) > Number(this.sortedData[i].max) || Number(this.sortedData[i].quantity) < Number(this.sortedData[i].min)) {
    //     valid = false;
    //     break;
    //   }
    // }
    // this.isValid = valid;

  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  viewSummary() {
    var deep = [ ...this.sortedData ];
    this.quoteService.stocklines$.next(deep);
    this.router.navigate(['viewSummary', this.expiry], { relativeTo: this.activeRouter })
  }


  close() {
    $('#levelOne').animate({ scrollLeft: (-252)}, 400);
    this.router.navigate(["../../../"], { relativeTo: this.activeRouter });
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
